import Page from 'src/apipages/libraries/examples/python/index';

export default Page;
